import get from './methods/get';

export default {
	sendHistoricalConsent: (consentGiven) =>
		get(`smartmeterreadings/historicaldata?consentGiven=${consentGiven}`),
	getHistoricalConsent: (agreementIdentifier) =>
		get(`smartmeterreadings/historicaldata/${agreementIdentifier}`),
	getHistoricalData: (ean) => get(`smartmeterreadings/csv/${ean}`, {}, true),
};
